import { Component, TemplateFunction } from '@ribajs/core'
import { hasChildNodesTrim } from '@ribajs/utils'
import { ToasterService } from '../services'

interface Scope {
  success: typeof ToasterService.prototype.success
  info: typeof ToasterService.prototype.info
  warning: typeof ToasterService.prototype.warning
  danger: typeof ToasterService.prototype.danger
}

/**
 * Simple preview component for the sb-toaster component used in the styleguide
 */
export class SbToasterPreviewComponent extends Component {
  public static tagName = 'sb-toaster-preview'

  protected toasterService = ToasterService.getSingleton()

  public scope: Scope = {
    success: this.toasterService.success.bind(this.toasterService),
    info: this.toasterService.info.bind(this.toasterService),
    warning: this.toasterService.warning.bind(this.toasterService),
    danger: this.toasterService.danger.bind(this.toasterService),
  }

  /**
   * Called as soon as this custom element es detected in the dom
   */
  protected connectedCallback() {
    super.connectedCallback()
    this.init([])
  }

  protected template(): ReturnType<TemplateFunction> {
    if (!hasChildNodesTrim(this)) {
      return (
        <p class="error">
          This component has no it's own template, you need to add your own
          child HTML
        </p>
      )
    }
    return null
  }
}
